import { AnimatePresence, motion } from 'framer-motion'
import { useCV } from './useCV'
import { Hero2D } from './scenes2d/Hero2D'
import { HumanVsCV2D } from './scenes2d/HumanVsCV2D'
import { Pixels2D } from './scenes2d/Pixels2D'
import { Tensor2D } from './scenes2d/Tensor2D'
import { Conv2D } from './scenes2d/Conv2D'
import { CNN2D } from './scenes2d/CNN2D'
import { Learning2D } from './scenes2d/Learning2D'
import { Detection2D } from './scenes2d/Detection2D'
import { Segmentation2D } from './scenes2d/Segmentation2D'
import { ViT2D } from './scenes2d/ViT2D'
import { Foundation2D } from './scenes2d/Foundation2D'
import { Multimodal2D } from './scenes2d/Multimodal2D'
import { Generative2D } from './scenes2d/Generative2D'
import { Universe2D } from './scenes2d/Universe2D'
import { Roadmap2D } from './scenes2d/Roadmap2D'

// Every chapter is now 2D (DOM/SVG/Canvas). The 3D canvas underneath only renders
// the ambient star-field backdrop.
export const SCENES_2D = [
  Hero2D,          // 0
  HumanVsCV2D,     // 1
  Pixels2D,        // 2
  Tensor2D,        // 3
  Conv2D,          // 4
  CNN2D,           // 5
  Learning2D,      // 6
  Detection2D,     // 7
  Segmentation2D,  // 8
  ViT2D,           // 9
  Foundation2D,    // 10
  Multimodal2D,    // 11
  Generative2D,    // 12
  Universe2D,      // 13
  Roadmap2D,       // 14
]

export function Scene2DLayer() {
  const scene = useCV(s => s.scene)
  const Active = SCENES_2D[scene]

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 5, pointerEvents: 'none' }}>
      <AnimatePresence>
        {Active && (
          <motion.div
            key={scene}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            style={{ position: 'absolute', inset: 0 }}
          >
            <Active />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
